import MPStorage from "@/services/LocalStorage";
export var buildHubStatsigUser = function (currentUser, partnerId) {
    var _a, _b;
    var clientID = currentUser.clients.length
        ? (_b = (_a = currentUser.clients[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : ""
        : "";
    var partnerID = partnerId !== null && partnerId !== void 0 ? partnerId : "";
    return {
        userID: MPStorage.requestCacheAuthenticate().userId,
        custom: {
            clientID: clientID,
            partnerID: partnerID
        },
        customIDs: {
            clientID: clientID,
            partnerID: partnerID
        }
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaHViU3RhdHNpZ1VzZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJodWJTdGF0c2lnVXNlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxPQUFPLFNBQVMsTUFBTSx5QkFBeUIsQ0FBQztBQUVoRCxNQUFNLENBQUMsSUFBTSxtQkFBbUIsR0FBRyxVQUNqQyxXQUE4QixFQUM5QixTQUFvQzs7SUFFcEMsSUFBTSxRQUFRLEdBQUcsV0FBVyxDQUFDLE9BQU8sQ0FBQyxNQUFNO1FBQ3pDLENBQUMsQ0FBQyxNQUFBLE1BQUEsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsMENBQUUsRUFBRSxtQ0FBSSxFQUFFO1FBQ2xDLENBQUMsQ0FBQyxFQUFFLENBQUM7SUFDUCxJQUFNLFNBQVMsR0FBRyxTQUFTLGFBQVQsU0FBUyxjQUFULFNBQVMsR0FBSSxFQUFFLENBQUM7SUFFbEMsT0FBTztRQUNMLE1BQU0sRUFBRSxTQUFTLENBQUMsd0JBQXdCLEVBQUUsQ0FBQyxNQUFNO1FBQ25ELE1BQU0sRUFBRTtZQUNOLFFBQVEsVUFBQTtZQUNSLFNBQVMsV0FBQTtTQUNWO1FBQ0QsU0FBUyxFQUFFO1lBQ1QsUUFBUSxVQUFBO1lBQ1IsU0FBUyxXQUFBO1NBQ1Y7S0FDRixDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=